'use client'

import { createContext, useContext, useState } from 'react'

const SlideshowContext = createContext(null)

export function SlideshowProvider({ children }) {
    const [currentSlide, setCurrentSlide] = useState(null)

    return (
        <SlideshowContext.Provider value={{ currentSlide, setCurrentSlide }}>
            {children}
        </SlideshowContext.Provider>
    )
}

export function useSlideshow() {
    return useContext(SlideshowContext)
}
